/* eslint-disable react/no-danger */
import classNames from 'classnames/bind';
import * as _ from 'lodash-es';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Footer';
import { Header } from '../Header';
import styles from '../styles.module.scss';
import UpcomingEvents from '../UpcomingEvents';
import VoloApp from '../VoloApp';
import cityMetadata from './metadata';
import {
  SportApprovedVenues,
  SportCompetitionLevels,
  SportFaqs,
  SportHero,
  SportPlayStyles,
  SportProgramTypes,
  SportRosterGrid,
} from './SportPageSections';
import { Button, Helmet } from '../../../../components';
import { ApprovedVenueProps, SportDetailsProps } from '../../../../types';
import { dashSpaceSwap } from '../../../../utils/url-search-helpers';

if (typeof window !== 'undefined') {
  // eslint-disable-next-line global-require
  require('react-responsive-carousel/lib/styles/carousel.min.css');
}

const cx = classNames.bind(styles);

const SportPagePresenter = props => {
  const {
    chosenSport,
    sportVenues,
    sportDetails,
    chosenCity,
    homepageDefaults,
    upcomingProgramTypes,
  } = props;

  const { formats = [], stylesOfPlay = [], notes = '', faq = [] } = sportDetails ?? {};

  return (
    <Helmet
      title={
        _.get(cityMetadata, `${chosenCity}.${chosenSport}.title`) ||
        `${chosenCity} ${chosenSport} | Volo ${chosenCity}`
      }
      meta={[
        { name: 'description', content: _.get(cityMetadata, `${chosenCity}.${chosenSport}.meta`) },
      ]}
    >
      <div className={cx('App', 'homepage', 'sportDetail')}>
        <Header />
        <SportHero {...{ ...props }} />
        <div className={cx('container', 'detailInfo', 'mt-5')}>
          <h1 className={cx('fancyText', 'mb-4')}>Overview</h1>
          <div className={cx('card')}>
            <div className="row">
              <div className="col-12">
                <p dangerouslySetInnerHTML={{ __html: notes }} />
              </div>
            </div>
          </div>
        </div>
        <div className={cx('titleHeader', 'mt-5', 'mb-0')}>
          <div className="container">
            <Link
              to={{
                pathname: '/discover',
                search: `?cityName=${dashSpaceSwap(
                  chosenCity,
                  'toSpace'
                )}&sportNames[]=${dashSpaceSwap(chosenSport, 'toSpace')}`,
              }}
            >
              <Button className={cx('ctaButton')}>Play {chosenSport} Now!</Button>
            </Link>
          </div>
        </div>
        <SportProgramTypes
          chosenCity={chosenCity}
          chosenSport={chosenSport}
          homepageDefaults={homepageDefaults}
          sportDetails={sportDetails}
          upcomingProgramTypes={upcomingProgramTypes}
        />
        <SportCompetitionLevels {...{ ...props }} />
        <div className={cx('container', 'detailInfo')}>
          <div className="row justify-content-center">
            {(stylesOfPlay || []).length > 0 && (
              <div className="col-12 col-md-6">
                <SportPlayStyles stylesOfPlay={stylesOfPlay} />
              </div>
            )}
            {(formats || []).length > 0 && (
              <div className="col-12 col-md-6">
                <SportRosterGrid formats={formats} />
              </div>
            )}
          </div>
        </div>
        <SportApprovedVenues chosenSport={chosenSport} sportVenues={sportVenues} />
        <UpcomingEvents cityName={chosenCity} chosenSport={chosenSport} />
        <SportFaqs faq={faq} />
        <VoloApp hideApp />
        <Footer />
      </div>
    </Helmet>
  );
};

SportPagePresenter.propTypes = {
  chosenSport: PropTypes.string.isRequired,
  chosenCity: PropTypes.string.isRequired,
  sportVenues: PropTypes.arrayOf(ApprovedVenueProps).isRequired,
  sportDetails: SportDetailsProps.isRequired,
  homepageDefaults: PropTypes.shape({
    programDescriptions: PropTypes.shape({}),
    programImages: PropTypes.shape({}),
  }).isRequired,
  upcomingProgramTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SportPagePresenter;
